export enum PreviewType {
  PREVIOUS = 'P',
  CURRENT = 'C',
}
